import React from 'react';
import styled from 'styled-components';
import img_bg from './img_bg.png';
import shopSelectors from 'services/shop/selectors';
import IcClose from 'features/coupon/receive-v2/IcClose';

interface BgDesktopCouponProps {
  children?: React.ReactNode;
  urlImage?: string;
}

const BgDesktopCoupon = ({ children, urlImage }: BgDesktopCouponProps) => {
  const shopInfo = shopSelectors.getShopInfo();
  return (
    <Container>
      <ContentBg>
        <ModalContainer>
          <LeftSection>
            <img
              src={urlImage ?? ''}
              alt='Background'
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </LeftSection>
          <RightSection>
            <a className='icon-close' href={shopInfo?.website || '/'}>
              <IcClose />
            </a>
            {children}
          </RightSection>
        </ModalContainer>
      </ContentBg>
    </Container>
  );
};

export default BgDesktopCoupon;

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url(${img_bg}) lightgray 50% / cover no-repeat;
`;

const ContentBg = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(25px);
`;

const ModalContainer = styled.div`
  width: 836px;
  min-height: 700px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
  display: flex;
  justify-content: center;
`;

const LeftSection = styled.div`
  flex: 1;
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
  img {
    border-top-left-radius: 16px;
    border-bottom-left-radius: 16px;
  }
`;

const RightSection = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #F6F7FC;
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
  .icon-close {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
  }
`;
